export const notificationChannelFns = {
    vision: {
        nhs: (incidentId) => `vision.incident.${incidentId}.nhs`,
        police: (incidentId) => `vision.incident.${incidentId}.police`,
    },
};
//# sourceMappingURL=thalamosNotification.js.map